<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsTextField v-model="tableData.filters.number" :label="$LANG.Get('fields.number')"></NevsTextField>
                <NevsSelect :nullable="true" v-model="tableData.filters.supplier_id" :ajax="'select/customers'"
                            :label="$LANG.Get('fields.supplier')"
                            @select="filterLabels.supplier_id = $event.label"></NevsSelect>
                <NevsDateField v-model="tableData.filters.date_of_issue_from"
                               :label="$LANG.Get('fields.date_of_issue_from')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.date_of_issue_to"
                               :label="$LANG.Get('fields.date_of_issue_to')"></NevsDateField>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="pdfClick(item.pdf_link)">{{ item.number }} {{ item.disclaimer }}</td>
                    <td class="nevs-table-linked-cell" @click="pdfClick(item.pdf_link)">{{ item.date_of_issue_display }}</td>
                    <td class="nevs-table-linked-cell" @click="pdfClick(item.pdf_link)">{{ item.supplier_display }}</td>
                    <td class="nevs-table-actions help-actions">
                        <NevsActions :width="'200px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";

export default {
    name: "ModuleReceiptNotes",
    components: {NevsTableFilters, NevsActions, NevsSelect, NevsDateField, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'number',
                        label: this.$LANG.Get('fields.number')
                    },
                    {
                        name: 'date_of_issue',
                        label: this.$LANG.Get('fields.dateOfIssue')
                    },
                    {
                        name: 'supplier',
                        label: this.$LANG.Get('fields.supplier'),
                        sortable: false
                    },
                    {
                        name: 'actions',
                        width: '290px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    number: '',
                    date_of_issue_from: null,
                    date_of_issue_to: null,
                    supplier_id: null,
                    item: ''
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'number',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.pdf'),
                    action: (item) => {
                        this.pdfClick(item.pdf_link);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.copy'),
                    action: (item) => {
                        this.copyClick(item.id);
                    },
                    visible: (item) => {
                        return item.invoice_status_id !== 5;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.cancel'),
                    action: (item) => {
                        this.cancelClick(item.id);
                    },
                    visible: (item) => {
                        return item.cancellable;
                    }
                }
            ],
            // Labels of the select filters, for the collapsed filter panel's summary. v-model only
            // carries the id, so the label is captured from NevsSelect's `select` event.
            filterLabels: {
                supplier_id: ''
            },
            crossTabHandle: null
        }
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed
        // here and the panel picks the active ones.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'number',
                    label: this.$LANG.Get('fields.number'),
                    value: filters.number
                },
                {
                    name: 'supplier_id',
                    label: this.$LANG.Get('fields.supplier'),
                    value: filters.supplier_id === null ? '' : this.filterLabels.supplier_id
                },
                {
                    name: 'date_of_issue_from',
                    label: this.$LANG.Get('fields.date_of_issue_from'),
                    value: filters.date_of_issue_from === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_from)
                },
                {
                    name: 'date_of_issue_to',
                    label: this.$LANG.Get('fields.date_of_issue_to'),
                    value: filters.date_of_issue_to === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_to)
                }
            ];
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        pdfClick(link) {
            window.open(link);
        },
        cancelClick(id) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.receiptNoteCancellationQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('post', 'receipt-notes/cancel/' + id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-receipt-notes', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                number: '',
                date_of_issue_from: null,
                date_of_issue_to: null,
                supplier_id: null,
                item: ''
            };
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.resolveWindowResize();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'receipt-notes/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        copyClick(id) {
            this.$router.push('/receipt-notes/' + id + '/copy');
        },
        addClick() {
            this.$router.push('/receipt-notes/0/add');
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'receipt-notes', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            let offset = 205;
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-actions',
                html: this.$LANG.Get('help.receiptNotesActions'),
                left: -220,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'receiptNotes');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.receiptNotes'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-receipt-notes', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}

</style>